import { TamaguiProvider, type TamaguiProviderProps } from 'tamagui';
import { tamaguiConfig } from './tamagui.config';

export type UiProviderProps = Omit<TamaguiProviderProps, 'config'> & {
  /** Theme name from tamagui.config — defaults to mrrmlab_light. */
  defaultTheme?: 'mrrmlab_light' | 'mrrmlab_dark';
};

/**
 * Wrap your app with this once at the root. Drops the mrrmlab Tamagui
 * config in, applies the default brand theme, and forwards everything else
 * (children, disableInjectCSS, etc.) to TamaguiProvider.
 */
export function UiProvider({ defaultTheme = 'mrrmlab_light', ...rest }: UiProviderProps) {
  return <TamaguiProvider config={tamaguiConfig} defaultTheme={defaultTheme} {...rest} />;
}
